// store.js
import { reactive } from 'vue'

export const store = reactive({
    serviceOverview: null,
    serviceShowAlpha: false,
    serviceActiveAlpha: null
})